import React from 'react';
import { clsx } from 'clsx';

const Card = ({ children, className, variant = 'default', onClick, ...props }) => {
  const variants = {
    default: 'courtyard-card',
    dark: 'courtyard-card-dark',
    philemon: 'courtyard-card bg-philemon-bg/60 border-courtyard-olive/30 hover:border-courtyard-olive/50',
    xenia: 'courtyard-card bg-xenia-bg/60 border-courtyard-aegean/30 hover:border-courtyard-aegean/50',
    theron: 'courtyard-card bg-theron-bg/60 border-courtyard-terracotta/30 hover:border-courtyard-terracotta/50',
    // Tools shared by all three guides ('all') get the neutral gold treatment
    all: 'courtyard-card bg-courtyard-gold/10 border-courtyard-gold/30 hover:border-courtyard-gold/50',
  };

  return (
    <div
      className={clsx(variants[variant], onClick && 'cursor-pointer', className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
